'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _sumBy2 = require('lodash/sumBy');

var _sumBy3 = _interopRequireDefault(_sumBy2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mightyFields = require('../../../lib/mighty-fields');

var _UnderwritingInsights = require('./UnderwritingInsights.js');

var _UnderwritingInsights2 = _interopRequireDefault(_UnderwritingInsights);

var _FieldSets = require('./FieldSets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var TabUnderwriting = (_dec = (0, _mobxReact.inject)('CaseStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(TabUnderwriting, _Component);

  function TabUnderwriting() {
    _classCallCheck(this, TabUnderwriting);

    return _possibleConstructorReturn(this, (TabUnderwriting.__proto__ || Object.getPrototypeOf(TabUnderwriting)).apply(this, arguments));
  }

  _createClass(TabUnderwriting, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          _case = _props._case,
          CaseStore = _props.CaseStore;

      CaseStore.fetchStateMVAThreshold(_case);
      CaseStore.fetchStatuteOfLimitations(_case);
    }
  }, {
    key: 'onCaseUpdate',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _props2, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, _case = _props2._case, CaseStore = _props2.CaseStore;
                _context.next = 3;
                return CaseStore.update({ caseId: _case.id, data: data });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCaseUpdate(_x) {
        return _ref.apply(this, arguments);
      }

      return onCaseUpdate;
    }()
  }, {
    key: 'onUnderwriterSummaryAnalysisUpdate',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var _props3, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props3 = this.props, _case = _props3._case, CaseStore = _props3.CaseStore;
                _context2.next = 3;
                return CaseStore.upsertUnderwriterSummaryAnalysis(_case.id, data);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onUnderwriterSummaryAnalysisUpdate(_x2) {
        return _ref2.apply(this, arguments);
      }

      return onUnderwriterSummaryAnalysisUpdate;
    }()
  }, {
    key: 'getUnderwriterCaseSummaryAnalysisTotalScore',
    value: function getUnderwriterCaseSummaryAnalysisTotalScore(underwriterSummaryAnalysisData) {
      var ratingTotal = (0, _sumBy3.default)(Object.values(underwriterSummaryAnalysisData), 'rating');

      return ratingTotal === 0 ? '--' : ratingTotal.toString();
    }
  }, {
    key: 'getUnderwriterSummaryAnalysisData',
    value: function getUnderwriterSummaryAnalysisData() {
      var _case = this.props._case,
          resultsList = (0, _get3.default)(_case, 'underwriter_case_summary_analyses'),
          underwriterSummaryAnalysisData = resultsList && resultsList.length !== 0 ? resultsList[0] : {},
          ratingTotal = this.getUnderwriterCaseSummaryAnalysisTotalScore(underwriterSummaryAnalysisData) + ' / 25';


      return _extends({}, underwriterSummaryAnalysisData, { ratingTotal: ratingTotal });
    }
  }, {
    key: 'render',
    value: function render() {
      var _case = this.props._case;


      return _react2.default.createElement(
        'div',
        { className: 'case-detail-tab tab-underwriting' },
        _react2.default.createElement(_mightyFields.EditableCard, {
          fieldSets: _FieldSets.FIELD_SETS_UNDERWRITER,
          model: _case,
          onSave: this.onCaseUpdate,
          title: 'Underwriter Evaluation'
        }),
        _react2.default.createElement(_mightyFields.EditableCard, {
          fieldSets: _FieldSets.FIELD_SETS_UNDERWRITER_ANALYSIS_SUMMARY,
          model: this.getUnderwriterSummaryAnalysisData(),
          onSave: this.onUnderwriterSummaryAnalysisUpdate,
          title: 'Underwriter Case Summary Analysis'
        }),
        _react2.default.createElement(_UnderwritingInsights2.default, {
          _case: _case
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TabUnderwriting;
}(_react.Component), _class2.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = TabUnderwriting;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabUnderwriting, 'TabUnderwriting', '/app/src/components/page-case/main-underwriting/TabUnderwriting.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-underwriting/TabUnderwriting.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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